export default "__VITE_ASSET__Cn2pi6Kk__"